export default __webpack_public_path__ + "static/josefina-lacroze-PsxFKMiEOM8-unsplash-59c469ead6e579c76d18e695fe60120b.jpg";